import sentryCatch from 'utils/sentryCatch/sentryCatch'

/**
 * @private
 * extract field name from backend error: "This [variable] is already in use"
 */
export const getInUseField = (message: string): string | undefined => {
  if (!message) {
    throw new Error(
      `[getInUseField] => Message is undefined, message: "${message}"`
    )
  }

  const match = message.match(/\[(.*?)\]/)

  if (!match) {
    return undefined
  }

  const fieldName = match[1]

  return fieldName
}

export default sentryCatch(getInUseField)
